const monad = (fns, fn) => fns.reduce((a, b) => [...a, fn(b)], [])

export const submitHandler = (api, transformer) => actions => event => {
  event.preventDefault()
  const isArray = Array.isArray(actions)
  const isFunc = typeof actions === 'function'
  const m = isFunc ? actions : isArray ? () => monad(actions, a => a()) : () => {}
  api.setState(transformer, m)
}

export const checkHandler = api => event => {
  let { name = '' } = event.target
  api.setState(prevState => ({ [name]: !prevState[name] }))
}

export const clickHandler = (api, prop) => event => {
  let { name = '' } = event.target
  api.setState({ [prop]: name })
}

export const inputHandler = api => event => {
  let { name = '', value = '' } = event.target
  api.setState({ [name]: value })
}

export const selectHandler = (api, prop) => event => {
  let { name = '' } = event.target
  api.setState(prevState => ({
    [prop]: prevState[prop] === name ? '' : name
  }))
}

export const toggleHandler = (api, prop, action) => event => {
  let { name = '' } = event.target
  api.setState({ [prop]: name }, action)
}
